import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import { customerColumns } from "./cols";
import { Customer, User } from "../../../models/Customer";
import { customer360Paths, rootPaths } from "../../../routes/routePaths";
import { usePermissionStore } from "../../../stores/permissionStore";
import CustomPagination from "../../atoms/CustomPagination";
import EmptyState from "../../atoms/EmptyState";

interface CustomerDataGridProps {
  data: Customer;
  loading?: boolean;
  onPageChange: (page: number) => void;
}

const CustomerDataGrid = ({
  data,
  loading,
  onPageChange,
}: CustomerDataGridProps) => {
  const { allowUnlockUser } = usePermissionStore();
  const navigate = useNavigate();
  const customerColumnsWithoutAction = customerColumns.filter(
    item => item.field !== "action",
  );
  return (
    <Stack height={800} alignItems="center">
      <DataGrid
        loading={loading}
        data-testid="customer-table"
        style={{ maxWidth: "100%", overflowX: "scroll" }}
        sx={{
          fontFamily: "Novera,sans-serif",
          fontSize: 14,
          lineHeight: "20px",
          fontWeight: 400,
          "& .MuiDataGrid-footerContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "primary.light",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "mono.white",
          },
          "& .MuiDataGrid-withBorderColor:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            whiteSpace: "unset",
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#E87722",
          },
        }}
        onCellClick={data => {
          const path = `${
            rootPaths.customer360
          }/${customer360Paths.customerDetail.replace(
            ":customerId",
            data.row.omneId,
          )}`;
          navigate(path);
        }}
        rows={data?.users || []}
        columns={
          allowUnlockUser ? customerColumns : customerColumnsWithoutAction
        }
        getRowId={(row: User) => row.omneId}
        slots={{
          pagination: CustomPagination,
          loadingOverlay: LinearProgress,
          noRowsOverlay: EmptyState,
        }}
        slotProps={{
          pagination: {
            count: data?.pagination?.totalPages,
            page: (data?.pagination?.currentPage ?? 1) - 1,
            onPageChange: (_, page) => {
              onPageChange(page + 1);
            },
          },
        }}
      />
    </Stack>
  );
};

export default CustomerDataGrid;
